import {
    INFORMES_LIST,
    INFORMES_LISTA,
    INFORMES_FILTER,
    INFORMES_CREATE,
    INFORMES_CREATE_SUCCESS,
    INFORMES_LIST_SUCCESS,
    INFORMES_REQUEST_FAILED,
    INFORMES_UPDATE,
    INFORMES_UPDATE_SUCCESS,
    INFORMES_READ,
    INFORMES_READ_SUCCESS,
  } from "./actionTypes";
  
  const initialState = {
    informes: [],
    informesCreated: {},
    informesUpdated: {},
    loading: false,
    error: "",
  };
  
  const informes = (state = initialState, action) => {
    switch (action.type) {
      case INFORMES_CREATE:
        state = {
          ...state,
          loading: true,
        };
        break;
      case INFORMES_LIST:
        state = {
          ...state,
          loading: true,
        };
        break;
      case INFORMES_LISTA:
        state = {
          ...state,
          loading: true,
        };
        break;
      case INFORMES_FILTER:
        state = {
          ...state,
          loading: true,
        };
        break;
      case INFORMES_UPDATE:
        state = {
          ...state,
          loading: true,
        };
        break;
      case INFORMES_READ:
        state = {
          ...state,
          loading: true,
        };
        break;
      case INFORMES_READ_SUCCESS:
        state = {
          ...state,
          loading: false,
          informesCreated: action.payload,
          error: "",
        };
        break;
      case INFORMES_CREATE_SUCCESS:
        state = {
          ...state,
          loading: false,
          informesCreated: action.payload,
          informesUpdated: {},
          error: "",
        };
        break;
      case INFORMES_LIST_SUCCESS:
        state = {
          ...state,
          loading: false,
          informes: action.payload,
          informesCreated: {},
          informesUpdated: {},
          error: "",
        };
        break;
      case INFORMES_UPDATE_SUCCESS:
        state = {
          ...state,
          loading: false,
          informesUpdated: action.payload,
          error: "",
        };
        break;
      case INFORMES_REQUEST_FAILED:
        state = {
          ...state,
          loading: false,
          error: action.payload,
        };
        break;
      default:
        state = { ...state };
        break;
    }
    return state;
  };
  
  export default informes;
  